import { Modal } from "antd";
import skinCareImg from "../../Assets/Images/AiReport/skinCare.svg"
import dentalCareImg from "../../Assets/Images/AiReport/dentalCare.svg"
import lungeCareImg from "../../Assets/Images/AiReport/lungCare.svg"
import visionCareImg from "../../Assets/Images/AiReport/visionCare.png"
import smartCareImg from "../../Assets/Images/AiReport/smartVital.svg"
const reportText = {
  skin_care: {
  headerTitle: "SkinCare:",
  title : "Preparing your image for upload...",
  headerSubtitle: "From a single image to powerful skin insights",
  imageSrc: skinCareImg,
  description: "Your photo will be securely uploaded and prepared for AI analysis. Once processed, our system will review tone, texture, spots, pigmentation, and irritation markers to generate your personalized skin assessment. You can explore other services while this step is completed.",
  },
  oral_care: {
    headerTitle: "OralCare:",
    title : "Preparing your images for upload...",
    headerSubtitle: "From a single photo to powerful oral health insights",
    imageSrc: dentalCareImg,
    description: "Your image will be securely uploaded and prepared for AI analysis. Once processed, our system will review your teeth and oral patterns to generate your personalized oral-health assessment. You can explore other services while this step is completed.",
  },
  lunge_care: {
    headerTitle: "LungeCare:",
    title : "Preparing your recording for upload...",
    headerSubtitle: "From a simple cough to powerful health insights",
    imageSrc: lungeCareImg,
    description: "Your audio will be securely uploaded and prepared for AI analysis. Once processed, our system will review breathing patterns, cough sound markers, and other respiratory signals to generate your personalized lungs assessment. You can explore other services while this step is completed.",
  },
  vision_care: {
    headerTitle: "VisionCare:",
    title : "Preparing your eye image for upload...",
    headerSubtitle: " From a single eye image to powerful eye insights",
    imageSrc: visionCareImg,
    description: "Your eye photo will be securely uploaded and prepared for AI analysis.Once processed, our system will review redness, dryness, irritation, infection, and other visible eye markers to generate your personalized eye health assessment. You can explore other services while this step is completed.",
  },
}
export default function AIReportUpload({
  solutionType,
  headerIcon,
  waitText = "Wait Here",
  onExplore,  
  onWait,
  visible = true,
  onCancel,
  customHeaderTitle,
  customHeaderColor,
  customTitle,
  customDescription,
  customDescriptionColor,
  customButtonText,
}) {
  return (
    <Modal open={visible} onCancel={onCancel} footer={null} centered width={680} style={{ maxWidth: '100vw' }}>
  <div className="bg-white px-4 md:px-10 flex flex-col items-center text-center mx-auto">

    {/* Header banner */}
    <div
      className="w-full flex items-center gap-2 p-3 rounded-md"
      style={{
        background: "var(--section-bg-gradient), #fff",
      }}
    >
      {headerIcon && (
        <img src={headerIcon} alt="icon" className="w-[19px] h-[24px] object-contain" />
      )}
      <span
        style={{
          fontFamily: "Inter, sans-serif",
          fontWeight: 700,
          fontSize: "15px",
          lineHeight: "20px",
          letterSpacing: "0px",
          background: "var(--primary-gradient)",
          WebkitBackgroundClip: "text",
          WebkitTextFillColor: "transparent",
          backgroundClip: "text",
        }}
      >
        {customHeaderTitle || reportText[solutionType].headerTitle}
      </span>
      {!customHeaderTitle && (
        <span
          style={{
            fontFamily: "Inter, sans-serif",
            fontWeight: 400,
            fontSize: "14px",
            lineHeight: "20px",
            letterSpacing: "0px",
            background: "var(--primary-gradient)",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
            backgroundClip: "text",
          }}
        >
          {reportText[solutionType].headerSubtitle}
        </span>
      )}
    </div>

    {/* Image */}
    <img
      src={reportText[solutionType].imageSrc}
      alt="Lungs Analysis"
      className="w-[250px] md:w-[350px] h-auto object-cover mx-auto"
    />

    {/* Title */}
    <h3
  className="font-inter font-semibold text-lg md:text-[24px] leading-[1.3] tracking-[0.3%] mt-6"
  style={{
    background: "var(--primary-gradient)",
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
    backgroundClip: "text",
    paddingBottom: "6px", // ✅ prevents cut
    display: "inline-block" // ✅ extra safety
  }}
>
  {customTitle || reportText[solutionType].title}
</h3>

    {/* Description */}
    <p
      className="font-medium text-sm md:text-lg tracking-[0.3%] text-center mt-4"
      style={{ color: customDescriptionColor || "#666666" }}
    >
      {customDescription || reportText[solutionType].description}
    </p>

    {/* Explore button */}
    <button
      className="w-full md:w-[364px] h-[48px] rounded-[24px] font-inter font-semibold text-sm md:text-[16px] mt-5"
      style={{ background: "var(--color-brand-primary)", color: "#fff", border: "none" }}
      onClick={onExplore}
    >
      {customButtonText || "Explore Services"}
    </button>

    {/* Wait Here */}
    {!customHeaderTitle && (
      <p
        className="font-inter font-semibold text-xs md:text-[14px] mt-4 cursor-pointer"
        style={{ textDecoration: "underline", color: "var(--color-brand-primary)" }}
        onClick={onWait}
      >
        {waitText}
      </p>
    )}

    {/* Footer note */}
    {!customHeaderTitle && (
      <p className="font-inter italic text-xs md:text-[14px] text-center mt-2" style={{ color: "#888" }}>
        A top progress bar will show the status. We'll notify you once it's ready.
      </p>
    )}
  </div>
</Modal>
  );
}
